import { useState } from 'react'
import { Text, Box, Stack, TextLinkButton, Button, TextField } from '@machobear/design-system'
import { isEmpty } from 'lodash'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'
import { FormBox, FormBoxSkeleton } from '../../components'

interface Props {
  isLoading: boolean
  data: any
  isError: boolean
}
const SummaryPurchase = ({ isLoading, data, isError }: Props) => {
  const { t } = useTranslation()
  const { setFieldValue } = useFormikContext()
  const [showField, setShowField] = useState(false)
  const [code, setCode] = useState('')
  const onClickApply = () => {
    setFieldValue('discount_code', code)
  }

  if (isLoading) {
    return (
      <FormBox label={t('Purchase Summary')}>
        <FormBoxSkeleton />
      </FormBox>
    )
  }

  if (isError) {
    return (
      <FormBox label={t('Purchase Summary')}>
        <Box>t('Unable to calculate cost of sponsored listing')</Box>
      </FormBox>
    )
  }

  return (
    <Box data-testid="SummaryPurchase">
      <FormBox label={t('Purchase Summary')}>
        <Stack space="small">
          <Box
            display="flex"
            justifyContent="spaceBetween"
            borderBottom="borderNeutralLight"
            paddingBottom="medium"
          >
            <Text>
              {data?.lineItem?.quantity} x {data?.lineItem?.prettyProductName}
            </Text>
            <Text>${data?.lineItem?.value}</Text>
          </Box>
          <Box borderBottom="borderField" paddingTop="xxsmall" paddingBottom="medium">
            <Stack space="small">
              <Box display="flex" justifyContent="spaceBetween">
                <Text>{t('b.payment.view.subtotal.label', 'Subtotal')}</Text>
                <Text>${data?.total_excluding_discount}</Text>
              </Box>
              <>
                {!showField ? (
                  <Text>
                    <TextLinkButton
                      onClick={() => {
                        setShowField(true)
                      }}
                    >
                      {t('b.payment.view.add_coupon.button', 'Add coupon')}
                    </TextLinkButton>
                  </Text>
                ) : (
                  <Box display="flex">
                    <Box style={{ flex: 4 }}>
                      <TextField
                        id="coupon"
                        placeholder=""
                        value={code}
                        onChange={(e: any) => setCode(e.target.value)}
                        label={t('Coupon code')}
                      />
                    </Box>
                    <Box style={{ flex: 1 }} paddingLeft="xsmall">
                      <Button
                        type="button"
                        variant="ghost"
                        size="large"
                        disabled={code?.length === 0}
                        onClick={onClickApply}
                      >
                        Apply
                      </Button>
                    </Box>
                  </Box>
                )}
              </>
              <Box display="flex" justifyContent="spaceBetween">
                <Text>GST/HST</Text>
                <Text>
                  {isEmpty(data?.metadata?.province || data?.metadata?.state)
                    ? '--'
                    : '$' + data?.tax}
                </Text>
              </Box>
            </Stack>
          </Box>
          <Box display="flex" justifyContent="spaceBetween">
            <Text size="large" weight="strong">
              {t('common.total', 'Total')}
            </Text>
            <Text size="large" weight="strong">
              $
              {isEmpty(data?.metadata?.province || data?.metadata?.state)
                ? `${data?.total_excluding_tax}`
                : `${data?.total}`}
            </Text>
          </Box>
        </Stack>
      </FormBox>
    </Box>
  )
}

export default SummaryPurchase
